/**
 * Header v4 draft: the department menus (computers, 990px and up). Loaded only when the header setting
 * "Header design" is v4.
 *
 * - Mouse: resting on a word opens its panel after a short beat; moving to another word switches quickly;
 *   leaving the word and its panel closes it after a short grace. A click opens or closes.
 * - Keyboard: Enter, Space, or Arrow Down opens; Tab moves from the word into its panel and on to the next
 *   word; Escape closes and returns to the word.
 * - The panel closes when the department bar tucks away on scroll, and when search opens.
 */
(function () {
  var header = document.querySelector('.header.header--ri.ri-hv4');
  if (!header) return;
  var panelsWrap = header.querySelector('[data-hv4-panels]');
  if (!panelsWrap) return;

  var OPEN_MS = 120;
  var SWITCH_MS = 60;
  var CLOSE_MS = 220;
  var desktop = window.matchMedia('(min-width: 990px)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var root = document.documentElement;

  var openKey = null;
  var openedByHoverAt = 0;
  var openTimer = null;
  var closeTimer = null;

  var scrim = document.createElement('div');
  scrim.className = 'hv4-scrim';
  scrim.setAttribute('aria-hidden', 'true');
  /* Inside the header section, like the search dim, so nothing on the page paints over it. */
  (header.closest('.section-header') || document.body).appendChild(scrim);

  function triggerFor(key) {
    return header.querySelector('[data-hv4-trigger="' + key + '"]');
  }

  function panelFor(key) {
    return panelsWrap.querySelector('[data-hv4-panel="' + key + '"]');
  }

  function focusables(panel) {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href]'), function (el) {
      return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null;
    });
  }

  function clearTimers() {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    openTimer = null;
    closeTimer = null;
  }

  /* Every panel hangs under its word and shifts left only to stay inside the header's content edge. */
  function place(panel, trigger) {
    var headerRect = header.getBoundingClientRect();
    var top = header.querySelector('.ri-header__top');
    var content = top ? top.getBoundingClientRect() : headerRect;
    var x = trigger.getBoundingClientRect().left - headerRect.left;
    panel.style.setProperty('--hv4-x', Math.round(x) + 'px');
    var overflow = panel.getBoundingClientRect().right - content.right;
    if (overflow > 0) {
      panel.style.setProperty('--hv4-x', Math.round(Math.max(content.left - headerRect.left, x - overflow)) + 'px');
    }
    lineFromWord(panel, trigger);
  }

  /* The panel's top stripe starts exactly where the word's underline is (the word's box less its side
     padding) and grows to the panel's width: scaling about point o by s maps the stripe [0, W] onto
     [o(1 - s), o + s(W - o)], so s = word width / W and o = word left / (1 - s). */
  function lineFromWord(panel, trigger) {
    var panelRect = panel.getBoundingClientRect();
    var stripeLeft = panelRect.left - 2;
    var stripeWidth = panelRect.width + 4;
    var wordRect = trigger.getBoundingClientRect();
    var pad = parseFloat(window.getComputedStyle(trigger).paddingLeft) || 0;
    var a = wordRect.left + pad - stripeLeft;
    var b = wordRect.right - pad - stripeLeft;
    var scale = Math.max(0.01, Math.min(1, (b - a) / stripeWidth));
    var origin = scale >= 0.999 ? 0 : a / (1 - scale);
    panel.style.setProperty('--hv4-start', scale.toFixed(4));
    panel.style.setProperty('--hv4-origin', origin.toFixed(1) + 'px');
    /* Restart the grow each time the panel opens. */
    panel.classList.remove('hv4-grow');
    void panel.offsetWidth;
    panel.classList.add('hv4-grow');
  }

  function warmPanel(panel) {
    if (!panel || panel._hv4Warm) return;
    panel._hv4Warm = true;
    panel.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  /* Late menus (ri-header-menus.js): a word reached for before its panel has arrived asks for the panels
     and opens once they land, if the mouse is still on the word, focus is still on it, or it was clicked. */
  var pendingOpen = null;

  function open(key, how) {
    if (!desktop.matches) return;
    if (header.classList.contains('ri-header--nav-collapsed')) return;
    if (openKey === key) return;
    var trigger = triggerFor(key);
    var panel = panelFor(key);
    if (trigger && !panel && panelsWrap.hasAttribute('data-ri-menus-late')) {
      pendingOpen = { key: key, how: how };
      document.dispatchEvent(new CustomEvent('ri:header-menus-need'));
      return;
    }
    if (!trigger || !panel) return;
    if (openKey) close(true);
    if (store && store.open) store.open = false;
    panel.hidden = false;
    place(panel, trigger);
    warmPanel(panel);
    trigger.setAttribute('aria-expanded', 'true');
    openKey = key;
    openedByHoverAt = how === 'hover' ? Date.now() : 0;
    root.classList.add('hv4-menu-open');
    if (how === 'keyboard') {
      var first = focusables(panel)[0];
      if (first) first.focus();
    }
  }

  function close(keepDim) {
    if (!openKey) return;
    var trigger = triggerFor(openKey);
    var panel = panelFor(openKey);
    if (panel) panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    openKey = null;
    if (!keepDim) root.classList.remove('hv4-menu-open');
  }

  function scheduleClose() {
    if (!finePointer.matches || !openKey) return;
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      close();
    }, CLOSE_MS);
  }

  header.querySelectorAll('.hv4-item').forEach(function (item) {
    var trigger = item.querySelector('[data-hv4-trigger]');
    item.addEventListener('mouseenter', function () {
      if (!finePointer.matches || !desktop.matches) return;
      if (!trigger) {
        scheduleClose();
        return;
      }
      var key = trigger.getAttribute('data-hv4-trigger');
      clearTimers();
      if (openKey === key) return;
      warmPanel(panelFor(key));
      openTimer = window.setTimeout(function () {
        open(key, 'hover');
      }, openKey ? SWITCH_MS : OPEN_MS);
    });
    item.addEventListener('mouseleave', function () {
      if (!trigger) return;
      window.clearTimeout(openTimer);
      scheduleClose();
    });
  });

  function bindPanels() {
    panelsWrap.querySelectorAll('.hv4-panel').forEach(function (panel) {
      if (panel._hv4Bound) return;
      panel._hv4Bound = true;
      panel.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', scheduleClose);
    });
  }
  bindPanels();

  document.addEventListener('ri:header-menus', function () {
    bindPanels();
    var wanted = pendingOpen;
    pendingOpen = null;
    if (!wanted) return;
    var trigger = triggerFor(wanted.key);
    if (!trigger) return;
    var still = wanted.how === 'click';
    if (wanted.how === 'hover') still = trigger.closest('.hv4-item').matches(':hover');
    if (wanted.how === 'keyboard') still = document.activeElement === trigger;
    if (still) open(wanted.key, wanted.how);
  });

  header.querySelectorAll('[data-hv4-trigger]').forEach(function (trigger) {
    var key = trigger.getAttribute('data-hv4-trigger');
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      clearTimers();
      if (openKey === key) {
        /* A menu the mouse just opened stays open when its word is clicked. */
        if (openedByHoverAt && Date.now() - openedByHoverAt < 700) return;
        close();
        return;
      }
      open(key, event.detail === 0 ? 'keyboard' : 'click');
    });
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (openKey !== key) open(key, 'keyboard');
        else {
          var first = focusables(panelFor(key))[0];
          if (first) first.focus();
        }
      } else if (event.key === 'Tab' && !event.shiftKey && openKey === key) {
        var firstLink = focusables(panelFor(key))[0];
        if (firstLink) {
          event.preventDefault();
          firstLink.focus();
        }
      }
    });
  });

  /* Tab past the last link returns to the bar at the next word; Shift+Tab from the first link returns to the word. */
  panelsWrap.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !openKey) return;
    var panel = panelFor(openKey);
    var links = focusables(panel);
    if (!links.length) return;
    var trigger = triggerFor(openKey);
    if (!event.shiftKey && document.activeElement === links[links.length - 1]) {
      event.preventDefault();
      var items = Array.prototype.slice.call(header.querySelectorAll('.hv4-trigger'));
      var next = items[items.indexOf(trigger) + 1];
      close();
      if (next) next.focus();
    } else if (event.shiftKey && document.activeElement === links[0]) {
      event.preventDefault();
      trigger.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !openKey) return;
    var trigger = triggerFor(openKey);
    close();
    if (trigger) trigger.focus();
  });

  document.addEventListener('click', function (event) {
    if (!openKey) return;
    if (event.target.closest('.hv4-panel') || event.target.closest('[data-hv4-trigger]')) return;
    close();
  });

  document.addEventListener('focusin', function (event) {
    if (!openKey) return;
    if (event.target.closest('.hv4-panel') || event.target.closest('[data-hv4-trigger]')) return;
    close();
  });

  /* Store chip: its panel hangs from the chip itself (ri-hv4.css), with the same dim as the department panels,
     and only one of them is open at a time. */
  var store = header.querySelector('[data-ri-store]');
  if (store) {
    store.addEventListener('toggle', function () {
      if (store.open) {
        if (openKey) close(true);
        root.classList.add('hv4-menu-open');
      } else if (!openKey) {
        root.classList.remove('hv4-menu-open');
      }
    });
  }

  /* Sell Your Games and the logo: clicked with the mouse, the next page shows them lifted (their hover look) until
     the mouse moves, since a browser leaves :hover off after a page load until the pointer moves (owner,
     2026-10-22: the logo dropped back into its shadow on the page it opened). A click records the time; the
     inline script after each link reads it. */
  function holdHover(el, key) {
    if (!el) return;
    el.addEventListener('click', function (event) {
      /* Keyboard, and clicks that open a new tab, keep this page. */
      if (event.detail === 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      try {
        window.sessionStorage.setItem(key, String(Date.now()));
      } catch (e) {}
    });
    /* The mouse left before the next page came up, so that page shows it flat (owner, 2026-10-23: it drew lifted,
       then dropped at the first move). */
    el.addEventListener('pointerleave', function () {
      try {
        window.sessionStorage.removeItem(key);
      } catch (e) {}
    });
    /* The inline script after the link marked it before the first paint; the first mouse move lets the real
       :hover take over. Not a scroll: a page scrolls itself while it loads, which dropped the logo with the mouse
       still on it and lifted it again at the next move, like a second click. */
    if (el.classList.contains('hv4-hover-held')) {
      var release = function () {
        el.classList.remove('hv4-hover-held');
        window.removeEventListener('pointermove', release, true);
      };
      window.addEventListener('pointermove', release, true);
    }
    /* Back to a page kept in memory: the hold from its first load no longer says where the mouse is. */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) el.classList.remove('hv4-hover-held', 'is-pressed');
    });
  }

  holdHover(header.querySelector('.ri-header__trade-quote:not(.ri-header__wishlist)'), 'ri-hv4-sell-hover');
  holdHover(header.querySelector('.header__heading-link'), 'ri-hv4-logo-hover');

  /* Close when the department bar tucks away on scroll, or when search opens. */
  function closeStore() {
    if (store && store.open) store.open = false;
  }
  new MutationObserver(function () {
    if (header.classList.contains('ri-header--nav-collapsed')) {
      close();
      closeStore();
    }
  }).observe(header, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(function () {
    if (root.classList.contains('ri-search-open')) {
      close();
      closeStore();
    }
  }).observe(root, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', function () {
    if (!openKey) return;
    if (!desktop.matches) {
      close();
      return;
    }
    place(panelFor(openKey), triggerFor(openKey));
  });
})();
